import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetReturnLoss from '@/modules/promotion/api/hooks/useQueryGetReturnLoss'
import ReturnLossListing from '@/modules/promotion/components/ReturnLoss/components/ReturnLossListing'

function ReturnLossPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
	}

	const { data, isLoading } = useQueryGetReturnLoss(payload)

	return (
		<PageContainer>
			<ReturnLossListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedReturnLossPage = withUserPermission(ReturnLossPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_RETURN_LOSS],
})

export default GuardedReturnLossPage
